import { createApi } from '@reduxjs/toolkit/query/react';
import { isNil } from 'lodash';

import { Project } from '../types/project';
import { createBaseQuery } from './api/baseApiConfig';
import config from '../config';

const baseUrl = 'project';

export const TAGS = {
	PROJECTS: 'PROJECTS',
	TIMELINE: 'TIMELINE',
};

export const projectApi = createApi({
	reducerPath: 'projectApi',
	baseQuery: createBaseQuery(`${config.APIM_BASE_URL}/${baseUrl}`),
	tagTypes: [TAGS.PROJECTS, TAGS.TIMELINE],
	endpoints: builder => ({
		fetchProjects: builder.query<Project[], { companyId: string; timelineId: string }>({
			query: ({ companyId, timelineId }) => {
				if (isNil(companyId) || isNil(timelineId)) {
					throw new Error('Company ID and Timeline ID are required');
				}

				return {
					method: 'GET',
					url: `/${companyId}/timeline/${timelineId}/projects`,
					params: { fetchTasks: true },
				};
			},
			providesTags: [TAGS.PROJECTS],
		}),
		fetchTimeline: builder.query<any, { companyId: string }>({
			query: ({ companyId }) => {
				if (isNil(companyId)) {
					throw new Error('Company ID is required');
				}

				return {
					method: 'GET',
					url: `/${companyId}/timeline`,
				};
			},
			providesTags: [TAGS.TIMELINE],
		}),
	}),
});

export const { useFetchProjectsQuery, useFetchTimelineQuery } = projectApi;
